export default __webpack_public_path__ + "static/media/hackerrankJSBasic.dabc4938.png";